module.exports = __webpack_public_path__ + "img/banner1.cb2b5a5e.png";